import $axios from "../http/accessor";
import { auth } from "../endpoints/auth.endpoints";

const AuthService = {
  login: (data: FormData) => {
    return $axios.post(auth.login, data);
  },

  loginGoogle: (code: string, redirectURI: string) => {
    const formData = new FormData();
    formData.append("code", code);
    formData.append("redirect_uri", redirectURI);
    return $axios.post(auth.login_google, formData);
  },

  register: (data: FormData) => {
    return $axios.post(auth.register, data);
  },

  logout: () => {
    return $axios.post(auth.logout);
  },

  sendOtp: (data: FormData) => {
    return $axios.post(auth.otp, data);
  },

  resendOtp: (data: FormData) => {
    return $axios.post(auth.resend_otp, data);
  },

  forgetPassword: (data: FormData) => {
    return $axios.post(auth.forget_password, data);
  },

  confirmForgetPassword: (data: FormData) => {
    return $axios.post(auth.confrim_forget_password, data);
  },

  getUserInfo: () => {
    return $axios.get(auth.get_user_info);
  },
  updateStoreInfo: (data: FormData) => {
    return $axios.put(auth.update_user_info, data);
  },

  setSavedBasket: (currency_id: number, data: FormData) => {
    return $axios.put(auth.set_saved_basket_data(currency_id), data);
  },
};

export default AuthService;
